/* istanbul ignore file */
import styled from 'styled-components';
import { ContainerV2 } from '../../stories/atoms/containerV2/ContainerV2';

export const DashboardGrid = styled(ContainerV2)<{ $isSmallDesktop: boolean }>`
  display: grid;
  grid-template-columns: ${({ $isSmallDesktop }) => ($isSmallDesktop ? '1fr' : 'repeat(2, 1fr)')};
`;
